module.exports = __webpack_public_path__ + "img/ic-loading-button.d3cf2199.svg";